export default "__VITE_PUBLIC_ASSET__23d76f43__"